<template>
  <NavPanelLink
    :active="isActive"
    :activeLink="activeLink"
    :class="$style.link"
    :item="item"
    :panelExpanded="panelExpanded"
  />
</template>

<script>
import { mapActions } from 'vuex';
import FundamentalsVisibilityMixin from 'client/components/mixins/fundamentalsVisibilityMixin';
import HomeWidgetConsts from 'client/Home/constants/HomeWidgetConsts';
import NavPanelLink from 'client/components/NavPanel/NavPanelLink.vue';
import NavPanelLinkListItem from 'client/components/NavPanel/NavPanelLinkListItem';

export default {
  name: 'HomeLink',

  components: {
    NavPanelLink,
  },

  mixins: [
    FundamentalsVisibilityMixin,
  ],

  props: {
    activeLink: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    item: {
      type: NavPanelLinkListItem,
      required: true,
    },
    panelExpanded: {
      type: Boolean,
      required: true,
    },
  },

  created() {
    this.fetchOrgSettings();
  },

  updated() {
    this.checkIfFundamentalsNeedsUpdated();
  },

  methods: {
    ...mapActions('SettingsModel', {
      fetchOrgSettings: 'fetchItem',
    }),

    ...mapActions('UserDisplayPreferencesModule', {
      setHomeWidgetVisibility: 'setHomeWidgetVisibility',
    }),

    checkIfFundamentalsNeedsUpdated() {
      // update when:
      if (
        // fundamentalsWidgetVisibility is truthy
        this.fundamentalsWidgetVisibility
        // and org is older than 30 days
        && !this.orgCreatedUnderThirtyDaysAgo
      ) {
        this.updateVisibility();
      }
    },

    updateVisibility() {
      const {
        widgetTypes: { fundamentals },
      } = HomeWidgetConsts;

      this.setHomeWidgetVisibility({
        widgetType: fundamentals,
        visible: false,
      });
    },
  },
};
</script>

<style module>
.link {
  margin-bottom: 20px;
}
</style>
